import React from "react";
import "./style.css";
import LabelSpan from "../LabelSpan";
export default function TextInput({
  label,
  required,
  className,
  placeholder,
  rows,
  value,
  onChange,
  disabled,
}) {
  const inputRequired = required ? (
    <span className="danger">&nbsp;*</span>
  ) : null;
  const inputLabel = label ? (
    <LabelSpan>
      {label}
      {inputRequired}
    </LabelSpan>
  ) : null;

  return (
    <label>
      {inputLabel}
      <textarea
        type="text"
        disabled={disabled}
        placeholder={`${placeholder}`}
        onChange={onChange}
        rows={rows}
        value={value}
        required={required}
      />
    </label>
  );
}
